import React from 'react';
import { bmsLogo as loginBmsLogo } from '../components/Images';

const LoginWrapper = ({ children }) => {
    return (
        <div className='login-content'>
            <div className='login-form-content'>
                <div className="login-form">
                    <div className="login-logo-container">
                        <img src={loginBmsLogo} alt="" className="login-logo" />
                    </div>
                    { children }
                </div>
            </div>
        </div>
    );
}

export default LoginWrapper;
